/**
 * Label UI per esiti log promemoria.
 *
 * Separato da `contract.ts` (contratto Brevo bloccato): solo presentazione.
 */

import type { PromemoriaEsito } from './contract';

export const PROMEMORIA_ESITO_LABELS: Record<PromemoriaEsito, string> = {
  inviato: 'Inviato',
  errore_api: 'Errore API',
  skip_no_email: 'Skip — no email',
  skip_disattivato: 'Skip — disattivato',
  skip_paziente_non_attivo: 'Skip — non attivo',
  skip_troppo_tardi: 'Skip — troppo tardi',
  skip_gia_inviato: 'Skip — già inviato',
  dry_run: 'Dry run',
};
